// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    firebase: {
        location: 'us-east1',
        apiKey: 'AIzaSyD1ADx-Pry0pdNEWK7Dwt9ujLBPn6poXF0',
        authDomain: 'aspe-312701.firebaseapp.com',
        projectId: 'aspe-312701',
        storageBucket: 'aspe-312701.appspot.com',
        messagingSenderId: '796472358297',
        appId: '1:796472358297:web:7ecc808cabd24e914a4f08',
        measurementId: 'G-WPVCJN01QK',
    },
    baseAPI: 'https://us-central1-aspe-312701.cloudfunctions.net',
    production: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
